var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"panelBlock"},[_c('v-flex',{attrs:{"tag":"h2"}},[_vm._v(_vm._s(_vm.toolKitConstants.FORUM_MEETING_TOOLS))]),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('ForumToolKit')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }